import React, { Fragment, useState, useEffect } from 'react';
import timeZoneList from '../../../../../data/timeZoneList';
import Switch from 'rc-switch';
import 'rc-switch/assets/index.css';
import { CardBody, Button, Card, CustomInput, Input, Label } from 'reactstrap';
import { Colxx } from '../../../../../components/common/CustomBootstrap';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import CompareArrowsOutlined from '@mui/icons-material/CompareArrowsOutlined';
import * as zChat from 'zendesk-chat-sdk';
import { Separator } from '../../../../../components/common/CustomBootstrap';
import Select from 'react-select';
import { reactSelectOptionDiffrentPro } from '../../../../../helpers/Utils';
import { AxiosAPI, getGroupID } from '../../../../../helpers/AxiosAPI';
import { API_Ingetration_Channels } from '../../../../../constants/APIs';
const Weekdays = [
  { value: 'Monday', name: 'Monday' },
  { value: 'Tuesday', name: 'Tuesday' },
  { value: 'Wednesday', name: 'Wednesday' },
  { value: 'Thursday', name: 'Thursday' },
  { value: 'Friday', name: 'Friday' },
  { value: 'Saturday', name: 'Saturday' },
  { value: 'Sunday', name: 'Sunday' },
  { value: 'Weekends', name: 'Weekends' },
  { value: 'Weekdays', name: 'Weekdays' },
];
const timeList = [
  { value: '0', name: '0:00' },
  { value: '1', name: '1:00' },
  { value: '2', name: '2:00' },
  { value: '3', name: '3:00' },
  { value: '4', name: '4:00' },
  { value: '5', name: '5:00' },
  { value: '6', name: '6:00' },
  { value: '7', name: '7:00' },
  { value: '8', name: '8:00' },
  { value: '9', name: '9:00' },
  { value: '10', name: '10:00' },
  { value: '11', name: '11:00' },
  { value: '12', name: '12:00' },
  { value: '13', name: '13:00' },
  { value: '14', name: '14:00' },
  { value: '15', name: '15:00' },
  { value: '16', name: '16:00' },
  { value: '17', name: '17:00' },
  { value: '18', name: '18:00' },
  { value: '19', name: '19:00' },
  { value: '20', name: '20:00' },
  { value: '21', name: '21:00' },
  { value: '22', name: '22:00' },
  { value: '23', name: '23:00' },
];
const LiveChat = ({
  liveChatSettings,
  saveIntegration,
  country,
  propertyData,
}) => {
  const [mewsList, setMewsList] = useState([]);
  const [amazonList, setAmazonList] = useState([]);
  const [timeZone, setTimeZone] = useState([]);
  const [liveChat, setLiveChat] = useState(
    liveChatSettings !== undefined && liveChatSettings !== null
      ? liveChatSettings
      : {
        enabled: false,
        displayRule: '3',
        outSideIndicator: false,
        businessHours: {
          timeZone: propertyData.timeZone,
          time: [
            {
              id: 1,
              hourFrom: '0',
              hourTo: '1',
              day: '',
            },
          ],
        },
        provider: 0,
        enableOutOfOfficeMessage: false,
        outOfOfficeMessage: '',
        enableConnectingMessage: false,
        connectingMessage: '',
        zendesk: { accountKey: '', department: '', departmentId: '' },
        genesysPureCloudSettings: {
          openMessageIntegrationId: '',
          appUserName: '',
          appPassword: '',
        },
      }
  );
  const [maskData, setMaskData] = useState({
    accountKey: '',
    department: '',
    departmentId: '',
    gpAppUserName: '',
    gpAppPassword: '',
    clientToken: '',
    accessToken: '',
  });
  const [zenDeskDepartments, setZenDeskDepartments] = useState([]);
  useEffect(() => {
    if (liveChat !== null && propertyData !== null) {
      let lst = liveChat.businessHours;
      if (lst.timeZone === '') {
        lst.timeZone = propertyData.timeZone;
        setLiveChat({ ...liveChat, businessHours: lst });
      }
    }
    let body = {
      channels: ['Mews', 'Amazon'],
    };
    AxiosAPI({
      method: 'post',
      url: `${API_Ingetration_Channels}?group_id=${getGroupID()}`,
      data: body,
    }).then((res) => {
      var integrations = res.data.filter((f) => f.disabled === false);
      if (integrations.length > 0) {
        const mews = integrations.filter((k) => k.channel === 'Mews');
        setMewsList(mews);
        const amazon = integrations.filter((k) => k.channel === 'Amazon');
        setAmazonList(amazon);
      }
    });
  }, [propertyData]);

  const mask = (value) => {
    let maskedValue = '';
    if (value !== undefined && value !== '' && value.length > 0) {
      for (let i = 0; i < value.length - 2; i++) {
        maskedValue += '*';
      }
      return maskedValue + value.substring(value.length - 2, value.length);
    }
    return maskedValue;
  };
  const handleBack = () => {
    setLiveChat(
      liveChatSettings !== undefined && liveChatSettings !== null
        ? liveChatSettings
        : {
          enabled: false,
          displayRule: '3',
          outSideIndicator: false,
          businessHours: {
            timeZone: propertyData.timeZone,
            time: [
              {
                id: 1,
                hourFrom: '0',
                hourTo: '1',
                day: '',
              },
            ],
          },
          provider: 0,
          zendesk: { accountKey: '', department: '', departmentId: '' },
          genesysPureCloudSettings: {
            openMessageIntegrationId: '',
            appUserName: '',
            appPassword: '',
          },
        }
    );
  };
  const createUUID = () => {
    const pattern = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx';
    return pattern.replace(/[xy]/g, (c) => {
      const r = (Math.random() * 16) | 0;
      const v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  };
  const AddBusinessHours = () => {
    let lst = liveChat.businessHours;
    lst.time.push({
      id: createUUID(),
      hourFrom: '0',
      hourTo: '1',
      day: Weekdays.filter((f) =>
        liveChat.businessHours.time.filter((l) => l.day === f.value)
      )[0],
    });
    setLiveChat({ ...liveChat, businessHours: lst });
  };
  const RemoveBusinessHours = (id) => {
    let lst = liveChat.businessHours;
    lst.time = lst.time.filter((f) => f.id !== id);

    setLiveChat({ ...liveChat, businessHours: lst });
  };
  const handleChange = (e) => {
    setLiveChat({ ...liveChat, [e.target.name]: e.target.value });
  };
  useEffect(() => {
    if (
      liveChatSettings !== undefined &&
      liveChatSettings !== null &&
      liveChatSettings.zendesk !== null
    ) {
      setMaskData({
        ...maskData,
        accountKey: mask(liveChatSettings.zendesk.accountKey),
        department: liveChatSettings.zendesk.department,
        departmentId: liveChatSettings.zendesk.departmentId,
        clientToken: mask(liveChatSettings?.mews?.clientToken),
        accessToken: mask(liveChatSettings?.mews?.accessToken),
        gpAppUserName: mask(
          liveChatSettings?.genesysPureCloudSettings?.appUserName
        ),
        gpAppPassword: mask(
          liveChatSettings?.genesysPureCloudSettings?.appPassword
        ),
      });
      //handleConnectZendesk();
    }
  }, [liveChatSettings]);

  useEffect(() => {
    let val = [];
    timeZoneList.map((m, index) => m.TimeZones.map((t) => val.push(t)));
    val = val.sort((a, b) => a.localeCompare(b));
    setTimeZone(val);
  }, [setTimeZone]);
  // const handleSwitchChange = (value) => {
  //     setLiveChat({ ...liveChat, displayRule: value });
  //     handleOnOff(!value)
  // }
  const handleAccountKeyChange = (e) => {
    e.persist();
    var zen = { ...liveChat };
    zen.zendesk.accountKey = e.target.value;
    setLiveChat(zen);
    setMaskData({ ...maskData, accountKey: e.target.value });
  };

  const handleMewsChange = (e) => {
    e.persist();
    var chat = { ...liveChat };
    if (e.target.name === 'mewsId') chat.mews.mewsId = e.target.value;
    else if (e.target.name === 'enterpriseId')
      chat.mews.enterpriseId = e.target.value;
    else if (e.target.name === 'client') chat.mews.client = e.target.value;
    else if (e.target.name === 'accessToken')
      chat.mews.accessToken = e.target.value;
    setLiveChat(chat);
  };

  const handleAmazonChange = (e) => {
    e.persist();
    var chat = { ...liveChat };
    if (e.target.name === 'amazonId') chat.amazon.amazonId = e.target.value;
    setLiveChat(chat);
  };

  const handleGenesysCloudIntegrationIdChange = (e) => {
    e.persist();
    var zen = { ...liveChat };
    zen.genesysPureCloudSettings.openMessageIntegrationId = e.target.value;
    setLiveChat(zen);
  };

  const handleGenesysCloudUserNameChange = (e) => {
    e.persist();
    var zen = { ...liveChat };
    zen.genesysPureCloudSettings.appUserName = e.target.value;
    setLiveChat(zen);
    setMaskData({ ...maskData, gpAppUserName: e.target.value });
  };

  const handleGenesysCloudPasswordChange = (e) => {
    e.persist();
    var zen = { ...liveChat };
    zen.genesysPureCloudSettings.appPassword = e.target.value;
    setLiveChat(zen);
    setMaskData({ ...maskData, gpAppPassword: e.target.value });
  };

  const handleTimeZone = (event) => {
    let lst = liveChat.businessHours;

    lst.timeZone = event.target.value;
    setLiveChat({ ...liveChat, businessHours: lst });
  };

  const handleSave = () => {
    if (liveChat.zendesk.accountKey !== '') {
      setMaskData({
        ...maskData,
        accountKey: mask(liveChat.zendesk.accountKey),
      });
    }
    if (liveChat.provider === 0) {
      liveChat.zendesk.accountKey = '';
      liveChat.zendesk.departmentId = '';
      liveChat.zendesk.department = '';
    }
    saveIntegration({ liveChat });
  };

  const handleConnectZendesk = () => {
    var connection_status = zChat.getConnectionStatus();
    if (connection_status == 'closed') {
      zChat.init({
        account_key: liveChat.zendesk.accountKey,
      });
      zChat.on('connection_update', function (status) {
        if (status === 'connected') {
          var departments = zChat.getAllDepartments();
          console.log(departments);
          setZenDeskDepartments(departments);
        } else if (status === 'closed') {
        }
      });
    } else if (connection_status == 'connected') {
      var departments = zChat.getAllDepartments();
      setZenDeskDepartments(departments);
    }
  };

  const handleChangeSelect = (e) => {
    console.log(e);
    var zen = { ...liveChat };
    zen.zendesk.department = e.label;
    zen.zendesk.departmentId = e.value;
    setLiveChat(zen);
    setMaskData({ ...maskData, department: e.label, departmentId: e.value });
  };
  const handleBusinessHours = (type, value, id) => {
    let businessHours = liveChat.businessHours;
    let time = businessHours.time.filter((f) => f.id === id);
    if (liveChat.businessHours.time.filter((f) => f.id === id).length > 0) {
      switch (type) {
        case 'hourFrom':
          businessHours.time.map((f) => {
            if (f.id === id) f.hourFrom = value;
            return f;
          });

          setLiveChat({
            ...liveChat,
            businessHours: businessHours,
          });
          break;

        case 'hourTo':
          businessHours.time.map((f) => {
            if (f.id === id) f.hourTo = value;
            return f;
          });

          setLiveChat({
            ...liveChat,
            businessHours: businessHours,
          });
          break;

        case 'day':
          businessHours.time.map((f) => {
            if (f.id === id) f.day = value;
            return f;
          });

          setLiveChat({
            ...liveChat,
            businessHours: businessHours,
          });
          break;
      }
    }
  };
  return (
    <Fragment>
      <Card>
        <CardBody>
          <div className='text-center'>
            <h6>Live Chat</h6>
          </div>
          <Separator className="mb-3" />
          <Card className="m-4 p-4">
            <Colxx xxs="12" className="px-0">
              <div className="text-left mb-3">
                <h5 style={{ marginTop: '0.15rem' }}>Availability</h5>
              </div>
              <div className="row mb-3 ml-0">
                <div className="d-flex w-100">
                  <h6 >Enable Live Chat</h6>
                  <Switch
                    className="agentswitch custom-switch-primary custom-switch-small ml-2"
                    checked={liveChat.enabled}
                    name="enabled"
                    onChange={(e) => {
                      setLiveChat({ ...liveChat, enabled: e });
                    }}
                  />
                </div>
                <p>
                  When enabled, the live chat option will be presented on your
                  website digital assistant widget.
                </p>
              </div>
              <div className="row mb-3 ml-0">
                <div className="d-flex w-100">
                  <h6>Display rules</h6>
                </div>
                <p>
                  Select when you want to present the live chat option to your
                  customers
                </p>
                <div className="w-100 ml-0">
                  <div className="row mt-2 ml-2">
                    <CustomInput
                      type="radio"
                      name="displayRule"
                      checked={liveChat.displayRule === 0 ? true : false}
                      onChange={(event) => {
                        setLiveChat({ ...liveChat, displayRule: 0 });
                      }}
                    >
                      Always visible
                    </CustomInput>
                  </div>
                  {/* <div className="w-100 ml-0">
                    <div className="row mt-1 ml-2">
                      <CustomInput
                        type="radio"
                        name='displayRule'
                        checked={liveChat.displayRule === 1 ? true : false}
                        onChange={event => {
                          setLiveChat({ ...liveChat, displayRule: 1 })
                        }}
                      >
                        Only when an agent is online
                      </CustomInput>
                    </div>
                  </div> */}
                  <div className="w-100 ml-0">
                    <div className="row mt-1 ml-2">
                      <CustomInput
                        type="radio"
                        name="displayRule1"
                        checked={liveChat.displayRule === 2 ? true : false}
                        onChange={(event) => {
                          setLiveChat({ ...liveChat, displayRule: 2 });
                        }}
                      >
                        Set your business hours
                      </CustomInput>
                    </div>
                  </div>
                </div>
                {liveChat.displayRule === 2 && (
                  <Fragment>
                    <div className="w-100 mt-3 ml-0">
                      <h6>Time Zone</h6>
                      <Colxx xxs="12" md="6" className="p-0 my-2 ">
                        <Input
                          type="select"
                          className="text-small dropdown-menu dropdowntimezone p-2 my-1"
                          name="type"
                          value={liveChat.businessHours.timeZone}
                          onChange={handleTimeZone}
                        >
                          {timeZone.length > 0 &&
                            timeZone.map((t) => (
                              <option className="dropdown-item" key={t} value={t}>
                                {t}
                              </option>
                            ))}
                        </Input>
                      </Colxx>
                    </div>
                    <div className='my-1'>Please note: This timezone setting only impacts Conversations live chat.</div>
                    {liveChat.businessHours.time.length > 0 &&
                      liveChat.businessHours.time.map((m, index) => (
                        <div key={m.id} className="w-90 d-flex align-items-center">
                          <Input
                            type="select"
                            value={m.day}
                            name="type"
                            onChange={(e) =>
                              handleBusinessHours('day', e.target.value, m.id)
                            }
                          >
                            <option value="0">Please Select</option>
                            {Weekdays.length > 0 &&
                              Weekdays.map((w, index) => {
                                // if (
                                //   liveChat.businessHours.time.filter(
                                //     (f) => f.day === w.value && f.id !== m.id
                                //   ).length == 0
                                // )
                                return (
                                  <option key={w.value} value={w.value}>
                                    {w.name}
                                  </option>
                                );
                              })}
                          </Input>
                          <Input
                            type="select"
                            className="ml-2"
                            value={m.hourFrom}
                            name="type"
                            onChange={(e) =>
                              handleBusinessHours(
                                'hourFrom',
                                e.target.value,
                                m.id
                              )
                            }
                          >
                            {timeList.length > 0 &&
                              timeList.map((m, index) => (
                                <option key={m.value} value={m.value}>
                                  {m.name}
                                </option>
                              ))}
                          </Input>
                          <span className="ml-2 my-2">to</span>
                          <Input
                            type="select"
                            className="ml-2"
                            value={m.hourTo}
                            name="type"
                            onChange={(e) =>
                              handleBusinessHours('hourTo', e.target.value, m.id)
                            }
                          >
                            {timeList.length > 0 &&
                              timeList.map((m, index) => (
                                <option key={m.value} value={m.value}>
                                  {m.name}
                                </option>
                              ))}
                          </Input>
                          <Button
                            color="danger"
                            size="xs"
                            className="ml-3 my-3 px-3"
                            outline
                            onClick={() => {
                              RemoveBusinessHours(m.id);
                            }}
                          >
                            <b>X</b>
                          </Button>
                        </div>
                      ))}
                    <div className="w-100 my-2 ml-0">
                      <Button
                        color="primary"
                        outline
                        size="xs"
                        onClick={AddBusinessHours}
                      >
                        Add hours
                      </Button>
                    </div>
                    <div className="w-100 my-3 ml-0 d-none">
                      <CustomInput
                        type="checkbox"
                        checked={liveChat.outSideIndicator}
                        onChange={(event) => {
                          setLiveChat({
                            ...liveChat,
                            outSideIndicator: event.target.checked,
                          });
                        }}
                      >
                        Display the live chat widget with an offline indicator
                        outside of business hours
                      </CustomInput>
                    </div>
                  </Fragment>
                )}
              </div>
              <div className="w-100 mb-3 ml-0">
                <div className="d-flex w-100">
                  <h6>Enable Connecting Message</h6>
                  <Switch
                    className="agentswitch custom-switch-primary custom-switch-small ml-2"
                    checked={liveChat.enableConnectingMessage}
                    name="enabled"
                    onChange={(e) => {
                      setLiveChat({ ...liveChat, enableConnectingMessage: e });
                    }}
                  />
                </div>
                <div className="mb-2 w-100">
                  <p className="mb-1">
                    When someone requests a live chat, this message is sent automatically.
                  </p>
                  <Input
                    type="textarea"
                    name="connectingMessage"
                    onChange={(e) => {
                      setLiveChat({
                        ...liveChat,
                        connectingMessage: e.target.value,
                      });
                    }}
                    placeholder="Thanks for your message — we’ll get back to you shortly"
                    value={liveChat?.connectingMessage}
                    style={{
                      width: '100%',
                      minHeight: '60px',
                      resize: 'both',
                      overflow: 'auto',
                    }}
                  />
                </div>
              </div>
              <div className="row mb-3 ml-0">
                <div className="d-flex w-100">
                  <h6>Enable Out of Office Message</h6>
                  <Switch
                    className="agentswitch custom-switch-primary custom-switch-small ml-2"
                    checked={liveChat.enableOutOfOfficeMessage}
                    name="enabled"
                    onChange={(e) => {
                      setLiveChat({ ...liveChat, enableOutOfOfficeMessage: e });
                    }}
                  />
                </div>
                <div className="mb-2 w-100">
                  <p className="mb-1">
                    If a chat is transferred to a live agent after hours, this message is sent automatically.
                  </p>
                  <Input
                    type="textarea"
                    name="outOfOfficeMessage"
                    onChange={(e) => {
                      setLiveChat({
                        ...liveChat,
                        outOfOfficeMessage: e.target.value,
                      });
                    }}
                    placeholder="You've reached us outside our business hours (Mon-Fri, 8 am-6 pm). We'll get back to you soon."
                    value={liveChat?.outOfOfficeMessage}
                    style={{
                      width: '100%',
                      minHeight: '60px',
                      resize: 'both',
                      overflow: 'auto',
                    }}
                  />
                </div>
              </div>
              <div className="row mb-3 ml-0">
                <h6>Choose Your Provider</h6>
                <div className="w-100 mt-1 ml-2">
                  <div className="d-flex flex-wrap">
                    <CustomInput
                      className="mr-2"
                      type="radio"
                      name="provider"
                      checked={liveChat.provider === 0 ? true : false}
                      onChange={(event) => {
                        setLiveChat({ ...liveChat, provider: 0 });
                      }}
                    >
                      Myma.ai
                    </CustomInput>
                    <CustomInput
                      className="mr-2"
                      type="radio"
                      name="provider1"
                      checked={liveChat.provider === 1 ? true : false}
                      onChange={(event) => {
                        setLiveChat({ ...liveChat, provider: 1 });
                      }}
                    >
                      Zendesk
                    </CustomInput>
                    <CustomInput
                      className="mr-2"
                      type="radio"
                      name="provider1"
                      checked={liveChat.provider === 2 ? true : false}
                      onChange={(event) => {
                        setLiveChat({ ...liveChat, provider: 2 });
                      }}
                    >
                      Genesys PureCloud
                    </CustomInput>
                    <CustomInput
                      className="mr-2"
                      type="radio"
                      name="provider3"
                      checked={liveChat.provider === 3 ? true : false}
                      onChange={(event) => {
                        setLiveChat({ ...liveChat, provider: 3 });
                      }}
                    >
                      Mews
                    </CustomInput>
                    <CustomInput
                      className="mr-2"
                      type="radio"
                      name="provider4"
                      checked={liveChat.provider === 4 ? true : false}
                      onChange={(event) => {
                        setLiveChat({ ...liveChat, provider: 4 });
                      }}
                    >
                      Amazon
                    </CustomInput>
                  </div>
                  {liveChat.provider === 3 && (
                    <Fragment>
                      <Colxx xxs="12" md="6" className="px-0 mt-3">
                        <Input
                          type="select"
                          name="mewsId"
                          onChange={handleMewsChange}
                          placeholder="Please Select"
                          value={liveChat?.mews?.mewsId}
                        >
                          <option value="">Please Select</option>
                          {mewsList.length > 0 &&
                            mewsList.map((m) => (
                              <option value={m.id}>{m.name}</option>
                            ))}
                        </Input>
                      </Colxx>
                    </Fragment>
                  )}
                  {liveChat.provider === 1 && (
                    <Fragment>
                      <Colxx xxs="12" md="8" className="px-0 mt-3">
                        <Label>Account Key</Label>
                        <Input
                          type="text"
                          name="accountKey"
                          onChange={handleAccountKeyChange}
                          placeholder="Account key"
                          defaultValue={maskData.accountKey}
                        />
                      </Colxx>
                      {liveChat.zendesk.department !== '' &&
                        zenDeskDepartments.length === 0 && (
                          <Colxx xxs="12" md="8" className="px-0 mt-3">
                            <Label>Default Department</Label>
                            <Input
                              type="text"
                              name="department"
                              defaultValue={liveChat.zendesk.department}
                              disabled="disabled"
                            />
                          </Colxx>
                        )}
                      {zenDeskDepartments.length > 0 && (
                        <Colxx xxs="12" md="8" className="px-0 mt-3">
                          <Fragment>
                            <Label>Default Department</Label>
                            <Select
                              isMulti={false}
                              className="react-select"
                              classNamePrefix="react-select"
                              name="departmentId"
                              placeholder="Select Department"
                              onChange={(e) => handleChangeSelect(e)}
                              defaultValue={liveChat.zendesk.departmentId}
                              options={
                                zenDeskDepartments
                                  ? reactSelectOptionDiffrentPro(
                                    zenDeskDepartments,
                                    true,
                                    'id',
                                    'name',
                                    ''
                                  )
                                  : []
                              }
                            />
                          </Fragment>
                        </Colxx>
                      )}
                      {zenDeskDepartments.length === 0 &&
                        liveChat.zendesk.accountKey !== '' && (
                          <Colxx xxs="12" md="8" className="px-0 mt-3">
                            <Button
                              onClick={handleConnectZendesk}
                              color="secondary"
                              outline
                              size="xs"
                              style={{ borderRadius: '6px' }}
                            >
                              Connect to Zendesk to Set the Default Department
                            </Button>
                          </Colxx>
                        )}
                    </Fragment>
                  )}
                  {liveChat.provider === 2 && (
                    <Fragment>
                      <Colxx xxs="12" md="8" className="px-0 mt-3">
                        <Label>Open Message Integration Id</Label>
                        <Input
                          type="text"
                          name="openMessageIntegrationId"
                          onChange={handleGenesysCloudIntegrationIdChange}
                          placeholder=""
                          defaultValue={
                            liveChat.genesysPureCloudSettings
                              .openMessageIntegrationId
                          }
                        />
                      </Colxx>
                      <Colxx xxs="12" md="8" className="px-0 mt-3">
                        <Label>Username</Label>
                        <Input
                          type="text"
                          name="appUserName"
                          onChange={handleGenesysCloudUserNameChange}
                          placeholder=""
                          defaultValue={maskData.gpAppUserName}
                        />
                      </Colxx>
                      <Colxx xxs="12" md="8" className="px-0 mt-3">
                        <Label>Password</Label>
                        <Input
                          type="text"
                          name="appPassword"
                          onChange={handleGenesysCloudPasswordChange}
                          placeholder=""
                          defaultValue={maskData.gpAppPassword}
                        />
                      </Colxx>
                    </Fragment>
                  )}
                  {liveChat.provider === 4 && (
                    <Fragment>
                      <Colxx xxs="12" md="6" className="px-0 mt-3">
                        <Input
                          type="select"
                          name="amazonId"
                          onChange={handleAmazonChange}
                          placeholder="Please Select"
                          value={liveChat?.amazon?.amazonId}
                        >
                          <option value="">Please Select</option>
                          {amazonList.length > 0 &&
                            amazonList.map((m) => (
                              <option value={m.id}>{m.name}</option>
                            ))}
                        </Input>
                      </Colxx>
                    </Fragment>
                  )}
                </div>
              </div>
            </Colxx>
          </Card >
          <Separator className="my-3" />
          <div className="text-center mb-2">
            <Button onClick={handleSave} size="xs" color="primary" className="mr-1">
              Save
            </Button>
            <Button color="secondary" size="xs" onClick={handleBack} className="ml-1">
              Reset
            </Button>
          </div>
        </CardBody >
      </Card >
    </Fragment >
  );
};
const mapStateToProps = ({ settings }) => {
  const { country } = settings;
  return {
    country,
  };
};

export default injectIntl(connect(mapStateToProps, {})(LiveChat));
